import React, { useEffect, useRef } from "react";
import { FaHeadset, FaClock, FaTicketAlt, FaWallet, FaPhoneAlt } from "react-icons/fa";

const BookingBenefitsCard = () => {
  const cardRef = useRef(null);

  useEffect(() => {
    const el = cardRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) el.classList.add("fade-visible");
      },
      { threshold: 0.2 }
    );
    observer.observe(el);
  }, []);

  return (
    <div
      ref={cardRef}
      className="fade-section bg-white/70 backdrop-blur-xl border border-gray-200 rounded-2xl shadow-xl p-6 flex flex-col md:flex-row md:justify-between gap-6 md:gap-10"
    >
      {/* Left Section - Benefits */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 flex-1">

        <div className="flex items-start gap-3 hover:scale-[1.02] transition-transform">
          <div className="bg-teal-100 p-3 rounded-xl">
            <FaHeadset className="text-teal-700 text-lg" />
          </div>
          <p className="text-sm md:text-base text-gray-700 font-medium">
            Expert guidance by certified travel specialists
          </p>
        </div>

        <div className="flex items-start gap-3 hover:scale-[1.02] transition-transform">
          <div className="bg-blue-100 p-3 rounded-xl">
            <FaClock className="text-blue-700 text-lg" />
          </div>
          <p className="text-sm md:text-base text-gray-700 font-medium">
            24/7 Dedicated Support Team
          </p>
        </div>

        <div className="flex items-start gap-3 hover:scale-[1.02] transition-transform">
          <div className="bg-emerald-100 p-3 rounded-xl">
            <FaTicketAlt className="text-emerald-700 text-lg" />
          </div>
          <p className="text-sm md:text-base text-gray-700 font-medium">
            Instant ticket confirmation
          </p>
        </div>

        <div className="flex items-start gap-3 hover:scale-[1.02] transition-transform">
          <div className="bg-purple-100 p-3 rounded-xl">
            <FaWallet className="text-purple-700 text-lg" />
          </div>
          <p className="text-sm md:text-base text-gray-700 font-medium">
            Flexible installment payment options
          </p>
        </div>

      </div>

      {/* Right Section - Call Now */}
      <div className="flex md:flex-col items-center md:items-end gap-3">
        <div className="bg-gradient-to-br from-teal-500 to-blue-500 p-4 rounded-full shadow-lg animate-pulse">
          <FaPhoneAlt className="text-white text-xl" />
        </div>
        <div className="text-center md:text-right">
          <p className="text-xs text-gray-500 font-medium">Need Help? Call Us Anytime</p>
          <a
            href="tel:+18887112909"
            className="text-lg font-bold text-teal-700 hover:text-teal-900 transition-all"
          >
            +1 888 711 2909
          </a>
        </div>
      </div>
    </div>
  );
};

export default BookingBenefitsCard;
